import { configurationApi } from '../configurationApi';
import { CompanyType } from '../types/companyType';

const companyEndpoints = configurationApi.injectEndpoints({
  endpoints: (builder) => ({
    getCompanies: builder.query<CompanyType[], void>({
      query: () => 'Company',
      providesTags: ['Company'],
    }),

    getCompany: builder.query<CompanyType, string>({
      query: (id) => `Company?id=${id}`,
      providesTags: (result, error, id) => [{ type: 'Company', id }],
    }),

    updateCompany: builder.mutation<boolean, CompanyType>({
      query: (company) => ({
        url: 'Company',
        method: 'POST',
        body: company,
      }),
      invalidatesTags: ['Company'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCompaniesQuery,
  useGetCompanyQuery,
  useUpdateCompanyMutation,
} = companyEndpoints;
